import { Environment } from '@contentsquare/global-constants';
export var CloudIdentifier;
(function (CloudIdentifier) {
    CloudIdentifier["NONE"] = "none";
    CloudIdentifier["AWS_EU"] = "aws-eu";
    CloudIdentifier["AZ_EU"] = "az-eu";
    CloudIdentifier["AZ_US"] = "az-us";
})(CloudIdentifier || (CloudIdentifier = {}));
export var CloudProvider;
(function (CloudProvider) {
    CloudProvider["Aws"] = "aws";
    CloudProvider["Azure"] = "azure";
})(CloudProvider || (CloudProvider = {}));
export var Region;
(function (Region) {
    Region["AWS_EU_WEST_1"] = "eu-west-1";
    Region["AWS_US_EAST_1"] = "us-east-1";
    Region["AZURE_EU_NORTH"] = "northeurope";
    Region["AZURE_US_EAST_2"] = "eastus2";
})(Region || (Region = {}));
export const CloudIdentifierToCloudProvider = {
    [CloudIdentifier.NONE]: 'none',
    [CloudIdentifier.AWS_EU]: CloudProvider.Aws,
    [CloudIdentifier.AZ_EU]: CloudProvider.Azure,
    [CloudIdentifier.AZ_US]: CloudProvider.Azure,
};
// CloudIdentifier should probably be deprecated in favor of Region
export const CloudIdentifierToRegion = {
    [CloudIdentifier.NONE]: 'none',
    [CloudIdentifier.AWS_EU]: Region.AWS_EU_WEST_1,
    // [CloudIdentifier.AWS_US]: Region.AWS_US_EAST_1,
    [CloudIdentifier.AZ_EU]: Region.AZURE_EU_NORTH,
    [CloudIdentifier.AZ_US]: Region.AZURE_US_EAST_2,
};
export const RegionToCloudProvider = {
    [Region.AWS_EU_WEST_1]: CloudProvider.Aws,
    [Region.AWS_US_EAST_1]: CloudProvider.Aws,
    [Region.AZURE_EU_NORTH]: CloudProvider.Azure,
    [Region.AZURE_US_EAST_2]: CloudProvider.Azure,
};
export const CloudProviderToBlobRegex = {
    [CloudProvider.Aws]: /^s3:\/\/[a-zA-Z0-9_.-]+\/(.*)$/,
    [CloudProvider.Azure]: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_.-]+@[a-zA-Z0-9_.-]+\/(.*)$/,
};
export function getAvailableCloudIdentifiers(env) {
    switch (env) {
        case Environment.Production:
            return [CloudIdentifier.AWS_EU, CloudIdentifier.AZ_EU];
        case Environment.Staging:
            return [CloudIdentifier.AWS_EU, CloudIdentifier.AZ_US];
        default: {
            return Object.values(CloudIdentifier).filter((cloudIdentifier) => cloudIdentifier !== CloudIdentifier.NONE);
        }
    }
}
//# sourceMappingURL=cloud.js.map